import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { regions: Object, allCountries: Array };
  static targets = ['regions', 'countries'];

  connect() {
    this.updateCountries();
  }

  updateCountries() {
    const regionsSelect = this.regionsTarget;
    const selectedRegionKeys = regionsSelect.tomselect
      ? regionsSelect.tomselect.items.slice() // values from Tom Select
      : Array.from(regionsSelect.selectedOptions).map((o) => o.value);

    const showAll = selectedRegionKeys.includes('global');

    let allowedCodes = new Set();
    if (showAll) {
      allowedCodes = new Set(this.allCountriesValue.map((c) => c.code));
    } else {
      selectedRegionKeys.forEach((k) => {
        const region = this.regionsValue[k];
        if (region && Array.isArray(region.countries)) {
          region.countries.forEach((code) => allowedCodes.add(code));
        }
      });
    }

    const list = showAll
      ? this.allCountriesValue
      : this.allCountriesValue.filter((c) => allowedCodes.has(c.code));

    const select = this.countriesTarget;

    if (select.tomselect) {
      const ts = select.tomselect;
      const prev = new Set(ts.items);

      ts.clearOptions(); // wipe options
      list.forEach(({ code, name }) => ts.addOption({ value: code, text: name }));
      ts.refreshOptions(false);

      const keep = [...prev].filter((v) => list.some((c) => c.code === v));
      ts.setValue(keep, true);
      return;
    }

    const prev = new Set(Array.from(select.selectedOptions).map((o) => o.value));
    select.innerHTML = '';
    list.forEach(({ code, name }) => {
      const opt = new Option(name, code, false, prev.has(code));
      select.add(opt);
    });
  }
}
